import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';
import _ from 'underscore';

export const MODULE_NAME = 'FILING_META_DATA_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');

export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doLoad: (filterParams) => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('doLoad(): filterParams: ', filterParams);
      CLIENT.getFilingMetaData(filterParams)
        .then((response) => {
          dispatch({type: LOAD_OK, response: response});
        })
        .catch((error) => {
          dispatch({type: LOAD_FAIL, error});
        });
    }
  }
};

export default API;

